class Pagination {
    constructor(element) {
        this.el = element;
        this.target = this.el.dataset.list;
        this.listing = document.querySelector(this.target);
        this.button = this.el.querySelector("a");
        this.form_filters = document.querySelector(".section--filters form");
        this.loading_indicator = document.querySelector("loading-indicator");

        this.parser = new DOMParser();

        this.init();
    }

    init() {
        this.button.addEventListener("click", this.paginate.bind(this));
    }

    async paginate(e) {
        e.preventDefault();

        this.loading_indicator.setAttribute("active", true);

        this.button.setAttribute("disabled", true);
        let query = {
            ajax: true,
        };

        if (this.form_filters) {
            let form_data = new FormData(this.form_filters);
            for (const pair of form_data.entries()) {
                query[pair[0]] = pair[1];
            }
        }

        const url = e.currentTarget.href;
        const payload = {
            method: "POST",
            credentials: "include",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded",
            }),
            body: new URLSearchParams(query).toString(),
        };
        const response = await fetch(url, payload);
        let data = await response.text();

        // Parse the text into HTML
        let doc = this.parser.parseFromString(data, "text/html");
        let cards = doc.querySelectorAll(`${this.target} [role="list"] li`);
        let pagination = doc.querySelector("[data-pagination]");

        let list = this.listing.querySelector('[role="list"]');

        if (list.hasAttribute("data-shuffle")) {
            const shuffleInstance = list.shuffle_instance;

            cards.forEach((card) => {
                shuffleInstance.element.appendChild(card);
            });
            shuffleInstance.add(cards);
        } else {
            cards.forEach((el) => {
                list.appendChild(el);
            });
        }

        if (typeof window.instgrm !== "undefined") {
            window.instgrm.Embeds.process();
        }

        if (pagination) {
            this.el.innerHTML = pagination.innerHTML;

            pagination = document.querySelectorAll("[data-pagination]");

            pagination.forEach((element) => {
                new Pagination(element);
            });
        } else {
            this.el.remove();
            pagination = null;
        }

        this.loading_indicator.setAttribute("active", false);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const pagination = document.querySelectorAll("[data-pagination]");

    pagination.forEach((element) => {
        new Pagination(element);
    });
});

export default Pagination;
